import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './dropdown.css';
import { append, $, addClasses } from '../../dom.js';
import { Emitter } from '../../../common/event.js';
import { BaseActionViewItem } from '../actionbar/actionViewItems.js';
import { DropdownMenu } from './dropdown.js';
import { asArray } from '../../../common/arrays.js';
export var DropdownMenuActionViewItem = /*#__PURE__*/function (_BaseActionViewItem) {
  _inherits(DropdownMenuActionViewItem, _BaseActionViewItem);

  var _super = _createSuper(DropdownMenuActionViewItem);

  function DropdownMenuActionViewItem(action, menuActionsOrProvider, contextMenuProvider) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, DropdownMenuActionViewItem);

    _this = _super.call(this, null, action, options);
    _this.options = options;
    _this._onDidChangeVisibility = _this._register(new Emitter());
    _this.menuActionsOrProvider = menuActionsOrProvider;
    _this.contextMenuProvider = contextMenuProvider;

    if (_this.options.actionRunner) {
      _this.actionRunner = _this.options.actionRunner;
    }

    return _this;
  }

  _createClass(DropdownMenuActionViewItem, [{
    key: "render",
    value: function render(container) {
      var _this2 = this;

      var labelRenderer = function labelRenderer(el) {
        _this2.element = append(el, $('a.action-label'));
        var classNames = _this2.options.classNames ? asArray(_this2.options.classNames) : []; // todo@aeschli: remove codicon, should come through `this.options.classNames`

        if (!classNames.find(function (c) {
          return c === 'icon';
        })) {
          classNames.push('codicon');
        }

        addClasses.apply(void 0, [_this2.element].concat(_toConsumableArray(classNames)));
        _this2.element.tabIndex = 0;

        _this2.element.setAttribute('role', 'button');

        _this2.element.setAttribute('aria-haspopup', 'true');

        _this2.element.setAttribute('aria-expanded', 'false');

        _this2.element.title = _this2._action.label || '';
        return null;
      };

      var options = {
        contextMenuProvider: this.contextMenuProvider,
        labelRenderer: labelRenderer,
        menuAsChild: this.options.menuAsChild
      }; // Render the DropdownMenu around a simple action to toggle it

      if (Array.isArray(this.menuActionsOrProvider)) {
        options.actions = this.menuActionsOrProvider;
      } else {
        options.actionProvider = this.menuActionsOrProvider;
      }

      this.dropdownMenu = this._register(new DropdownMenu(container, options));

      this._register(this.dropdownMenu.onDidChangeVisibility(function (visible) {
        var _a;

        (_a = _this2.element) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', "".concat(visible));

        _this2._onDidChangeVisibility.fire(visible);
      }));

      this.dropdownMenu.menuOptions = {
        actionViewItemProvider: this.options.actionViewItemProvider,
        actionRunner: this.actionRunner,
        getKeyBinding: this.options.keybindingProvider,
        context: this._context
      };

      if (this.options.anchorAlignmentProvider) {
        var that = this;
        this.dropdownMenu.menuOptions = Object.assign(Object.assign({}, this.dropdownMenu.menuOptions), {
          get anchorAlignment() {
            return that.options.anchorAlignmentProvider();
          }

        });
      }
    }
  }, {
    key: "setActionContext",
    value: function setActionContext(newContext) {
      _get(_getPrototypeOf(DropdownMenuActionViewItem.prototype), "setActionContext", this).call(this, newContext);

      if (this.dropdownMenu) {
        if (this.dropdownMenu.menuOptions) {
          this.dropdownMenu.menuOptions.context = newContext;
        } else {
          this.dropdownMenu.menuOptions = {
            context: newContext
          };
        }
      }
    }
  }]);

  return DropdownMenuActionViewItem;
}(BaseActionViewItem);